'use strict';

export default class MemFeeListCtrl {
  constructor($stateParams, LoaderSvc, MemFeeSvc, GroupAuthSvc) {
    LoaderSvc.start('Loading Member Fees...');
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId; // set for group urls
    var groupId = $stateParams.groupId;
    this.groupId = Number(groupId); // convert to number for disable link check

    // authorization
    GroupAuthSvc.validatePermission(groupId, 'memberFee', 'I');

    that.dataModel = 'mfvm';
    MemFeeSvc.getDefinedFor({groupId}).$promise
      .then(function(data) {
        that.data = data;
        that.order = 'name';
        that.searchField = 'name';
        LoaderSvc.stop();
      })
      .catch(function() { LoaderSvc.stopError('Error loading Member Fees'); });
  }
}

MemFeeListCtrl.$inject = [
  '$stateParams',
  'LoaderSvc',
  'MemFeeSvc',
  'GroupAuthSvc'
];
